const SidebarProfile = ({ name, email, initial = "I", photoUrl = "" }) => {
    return (
        <div className="px-4">
            <div className="relative shrink-0">
                <div className="flex h-24 w-24 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-[#d6dbe6] to-[#c3c8d8] text-lg font-semibold text-slate-700">
                    {photoUrl
                        ? <img src={photoUrl} alt={name} className="h-full w-full object-cover" />
                        : initial
                    }
                </div>
                <img src="/assets/icons/blue-tick.svg" alt="" className="absolute top-4 left-20 h-5 w-5" />
            </div>
            <div className="min-w-0">
                <p className="truncate text-sm font-bold text-primary">{name}</p>
                <p className="truncate text-xs text-slate-500 mt-0.5">{email}</p>
            </div>
        </div>
    );
};

export default SidebarProfile;
